export default function createSiteBillingReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'CREATE_SITE_BILLING_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'CREATE_SITE_BILLING_ERROR':
            return {...state, ...{error: action.error}};

        case 'CREATE_SITE_BILLING_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}